import { render, staticRenderFns } from "./turnoRutas.vue?vue&type=template&id=e496a7d2&scoped=true"
import script from "./turnoRutas.vue?vue&type=script&lang=js"
export * from "./turnoRutas.vue?vue&type=script&lang=js"
import style0 from "./turnoRutas.vue?vue&type=style&index=0&id=e496a7d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e496a7d2",
  null
  
)

export default component.exports